<template>
  <v-card flat>
    <h1>{{ $t('application.instructor.personalNumber.title') }}</h1>
    <p>{{ $t('application.instructor.personalNumber.info') }}</p>

    <MessageBox class="my-5" type="info" :closable="false">
      <h6>{{ $t('application.instructor.personalNumber.mb-title') }}</h6>
      <p v-html="$t('application.instructor.personalNumber.mb-info')"></p>
    </MessageBox>
    <!-- Form with personal number input field -->
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        outlined
        :append-icon="okIcon"
        v-model="model"
        v-mask="mask"
        :placeholder="$t('labels.personalNumberPlaceholer')"
        :rules="[rules.required, rules.pnr13, rules.swePnr]"
        required
      ></v-text-field>
    </v-form>
    <!--Enable if personal number is correct and  go to a next  step-->
    <NextButton
      :isDisabled="!valid || (model && model.length <= 0)"
      class="mt-6"
      @click="nextStep"
    >{{ $t('tour.next') }}</NextButton>
    <!-- Go to a previous  step-->
    <BottomNav @clicked="$emit('goToStep', '-1')" />
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import {RulesMixin} from '@/components/mixins'
import {mask} from 'vue-the-mask'
import NextButton from '@/components/Common/NextButton'
import MessageBox from '@/components/Common/MessageBox'
import BottomNav from '@/components/Application/BottomNav'
// @group Application-Company
// ApplicationPersonalNumber component
export default {
  name: 'ApplicationPersonalNumber',

  mixins: [RulesMixin],

  components: {
    NextButton,
    BottomNav,
    MessageBox
  },

  directives: {
    mask
  },

  data: () => ({
    mask: '########-####',
    model: '',
    application: null,
    fields: ['id', 'personalNumber'],
    valid: false
  }),

  created() {
    /**
     * @vuese
     * Used to reset form validation and call  initApplication function
     */
    if (this.$refs.form && this.$refs.form !== undefined) {
      this.$refs.form.resetValidation()
    }

    this.initApplication()
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication , reset validation  and call initApplication function
     */
    selectedApplication: {
      handler: function () {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
          console.log(this.$refs.form.resetValidation());
        }

        this.initApplication()
      },
      deep: true
    },
    /**
     * @vuese
     * Used to watch the currentStep , reset validation and call initApplication
     * @arg called with no argument
     */
    currentStep: {
      handler: function () {
        this.initApplication()
      },
      deep: true
    },
    /**
     * @vuese
     * Used to watch the personal number changes and replace the dash with empty space
     */
    model(val) {
      if (val) {
        this.application.personalNumber = val.replace(/\D/g, '')
      }
    }
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    ...mapGetters('currentuser', ['currentUser']),

    /**
     * @vuese
     * Used to add this specific icon if personal number is correct
     */
    okIcon() {
      return this.valid && this.model && this.model.length > 0 ? '$sl-steper-check' : ''
    }
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),

    /**
     * @vuese
     * Used to Initialize application with either selected personal number or empty personal number field
     */
    initApplication() {
      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields)
        this.model = this.application.personalNumber
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
      }
      this.application.step = this.currentStep
    },
    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with personal number field
     * @arg The argument is an integer value application  id and params are the selected fields
     */
    async nextStep() {
      if (!this.$refs.form.validate()) {
        return this.$events.fire('showError', this.$t('errors.form-validation'))
      }

      if (this.application.id && this.application.id > 0) {
        API.updateApplication(this.application.id, {data: this.application})
          .then(() => {
            /**
             * @vuese
             * Used to update application in vuex store
             * @arg The params are current fields of the application
             */
            this.updateSelectedApplication(this.application)
            // Fire +1
            // @arg The argument is a integer representing (in which step to go)
            this.$emit('goToStep', '+1')
          })
          .catch(error => {
            if ( this.rules.isMinor(this.model) ) {
              return this.$dialog.confirm({
                title: this.$i18n.t('dev-buttons.underage'),
                text: this.$i18n.t('errors.rules.is-minor'),
                actions: [
                  { text: this.$t('labels.close'), key: true, icon: '$sl-close' }
                ]
              })
            }
            this.$events.fire('showError', this.$t('errors.save-failure'))
          })
      }
    }
  }
}
</script>

<style scoped>
</style>
